import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { DeleteSpendBudgetFeebackLeaddeliveryComponent } from '../delete-spend-budget-feeback-leaddelivery/delete-spend-budget-feeback-leaddelivery.component';

@Component({
  selector: 'app-feedback-list-modal',
  templateUrl: './feedback-list-modal.component.html',
  styleUrls: ['./feedback-list-modal.component.scss']
})
export class FeedbackListModalComponent implements OnInit {

  authToken = localStorage.getItem("token")
  deleteSpendBudgetFeebackLeaddeliveryComponent:MatDialogRef<DeleteSpendBudgetFeebackLeaddeliveryComponent>;

  feedbackList: any;

  showComponentLoader: boolean = true;

  campaignRowData: any;

  headerStats: any;
  userInfo = JSON.parse(localStorage.getItem('userInfo'))
  platformWiseData:any =[];

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<FeedbackListModalComponent>,
    private datePipe: DatePipe,
    private dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    //console.log(data)
    this.campaignRowData = data;
    // console.log(this.userInfo.role)
  }

  ngOnInit() {
    this.getFeedbackList()
    this.getSpentBudgetDeliveryStats()
  }

  getSpentBudgetDeliveryStats() {

    this.showComponentLoader = true;

    //let url = "campaign_module/campaign/spent_budget_delivery_stats/"+this.data.id;
    let url = "campaign_module/lead_feedback_analysis/get_lead_feedback_analysis_stats?campaign_id=" + this.data.id;

    this.serverService.getSpentBudgetDeliveryStats(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.headerStats = data.stats[0]
      if(this.headerStats){
      if(this.headerStats.source_wise){
        this.platformWiseData = JSON.parse(this.headerStats.source_wise);
        //  console.log(this.platformWiseData)
         this.platformWiseData = this.platformWiseData.platforms;
      }
      }
    //  console.log(this.platformWiseData)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getFeedbackList() {

    this.showComponentLoader = true

    let body: any = {
      "campaign_id": this.campaignRowData.id
    }

    let url = "/campaign_module/lead_feedback_analysis/get_list";

    this.serverService.getFeedbackList(url, body, this.authToken).subscribe(data => {
      this.feedbackList = data
      // console.log(data)
      this.showComponentLoader = false
    }, err => {
      this.showComponentLoader = false
      this.clipBoardService.checkServerError(err, this.authToken)
    })

  }
  formatPlatformWise(item:any):any{
    // console.log(JSON.parse(item))
    if(item){
    let temp = (JSON.parse(item))
  
    return temp.platforms
    }
    return ''
  }
  close() {
    this.dialogRef.close();
  }
  getExtension(fileName:any){
    return fileName.split('.').pop()
  }
  getCSV(url: any, date:any,extension:any, i:any) {
       let fileExtension = this.getExtension(extension);
     
      fetch(url)
          .then(response => response.blob())
          .then(blob => {
              // Create a temporary link element
              var link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = 'feedback-'+date +'.'+fileExtension ; // Suggested filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              // Cleanup the object URL after download
              URL.revokeObjectURL(link.href);
          })
          .catch(error => console.error('Download error:', error));


  }
  deleteSpend(item:any,type:any){
    item['type'] = type;
    this.deleteSpendBudgetFeebackLeaddeliveryComponent = this.dialog.open(DeleteSpendBudgetFeebackLeaddeliveryComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '520px',
      panelClass: 'blue-snackbar',
      data: item
    });
    this.deleteSpendBudgetFeebackLeaddeliveryComponent.afterClosed().subscribe(result => {
      // console.log(result)
      if(result != undefined){
        this.feedbackList = this.feedbackList.filter((item)=>item.id != result.id)
        this.getSpentBudgetDeliveryStats()
      //  console.log(this.brochures)
        }
        
    });
    
  }
  
}